
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 15.74 15.74\" id=\"close\" ><defs/><title>close</title><g id=\"close_Layer_2\" data-name=\"Layer 2\"><g id=\"close_Icons\"><path class=\"cls-1\" d=\"M0 14.44l6.59-6.58L0 1.3 1.3 0l6.56 6.56L14.44 0l1.3 1.3-6.59 6.56 6.59 6.58-1.3 1.3-6.58-6.59-6.56 6.59-1.3-1.3z\" id=\"close_close\"/></g></g></symbol>";
module.exports = sprite.add(image, "close");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = 647
// module chunks = 1474